const CameraY = 5;

export const CanvasOptions = {
  position: [0, CameraY, 2],
  groupChatCameraPosition: [0, CameraY, 2.5],
  fov: 35,
  groupChatFov: 60,
  lightDirectColor: 0x8888aa,
  lightAmbientColor: 0xffffff,
  spotLightColor: 0xffffff,
  spotLightIntensity: 0.2,
  ambientLightIntensity: 0.1,
  lightSpotDispersion: 1,

  character_position: [0, 0, 0],

  asset: {
    cameraPosition: [0, 0.5, 4],
    cameraFov: 45,
    characterPosition: [0, -0.6, 0],
  },
} as const;

export const AnimationDuration = {
  idle: 5,
  texting: 4,
} as const;
